/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useEffect, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { withRouter } from 'react-router';
import { saveAs } from 'file-saver';
import { getPdfQrcode } from './api';
import './index.css';
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';

function pdfContentUrl(pdfName, retryToken = '') {
  const baseUrl = `/api/qrcode/pdf-qrcodes/name/${encodeURIComponent(pdfName)}/content`;
  return retryToken ? `${baseUrl}?retry=${encodeURIComponent(retryToken)}` : baseUrl;
}

const PDF = (props) => {
  const pdfName = props.match.params.name;
  const [data, setData] = useState({
    name: '',
    title: '',
    companyName: '',
    pdfUrl: '',
    website: '',
  });
  const [pdfSrc, setPdfSrc] = useState(null);
  const [pdfError, setPdfError] = useState('');

  const pageNumber = 1;

  function onDocumentLoadSuccess() {
    setPdfError('');
  }

  function onDocumentLoadError(error) {
    let pdfHost = '';
    try {
      pdfHost = data.pdfUrl ? new URL(data.pdfUrl).hostname : '';
    } catch (_) {
      pdfHost = '';
    }
    console.error('[PDF_VIEWER] Unable to render PDF', {
      message: error && error.message,
      name: error && error.name,
      pdfHost,
    });
    setPdfError('Không thể hiển thị tài liệu. Vui lòng thử lại hoặc tải file về máy.');
  }

  useEffect(() => {
    let active = true;
    
    // Kiểm tra nếu đã skip ads từ URL params
    const urlParams = new URLSearchParams(window.location.search);
    const skipAds = urlParams.get('skipAds');
    
    getPdfQrcode(pdfName).then((response) => {
      if (!active) return;
      setData(response);
      
      // Kiểm tra nếu có ads = true và chưa skip ads thì redirect đến ads.html
      if (response.ads === true && !skipAds) {
        // Tạo URL cho ads.html với thông tin PDF
        const adsUrl = new URL('/review.html', window.location.origin);
        const returnUrl = new URL(window.location.href);
        returnUrl.searchParams.set('skipAds', 'true');

        adsUrl.searchParams.set('pdfId', response.id || response._id);
        adsUrl.searchParams.set('pdfUrl', response.pdfUrl);
        adsUrl.searchParams.set('fileName', response.fileName);
        adsUrl.searchParams.set('title', response.title);
        adsUrl.searchParams.set('companyName', response.companyName);
        adsUrl.searchParams.set('website', response.website);
        adsUrl.searchParams.set('returnUrl', returnUrl.toString());
        
        // Redirect đến ads.html
        window.location.href = adsUrl.toString();
        return;
      }
      
      // Nếu không có ads hoặc đã skip ads, xử lý bình thường
      if (response.pdfUrl) {
        setPdfSrc(pdfContentUrl(pdfName));
      }
    }).catch((error) => {
      if (!active) return;
      console.error('[PDF_VIEWER] Unable to load PDF metadata', error);
      setPdfError('Không thể tải thông tin tài liệu. Vui lòng thử lại.');
    });

    return () => { active = false; };
  }, [pdfName]);

  const retryPdf = () => {
    setPdfError('');
    if (!pdfName) {
      window.location.reload();
      return;
    }
    setPdfSrc(pdfContentUrl(pdfName, Date.now().toString()));
  };

  const saveFile = () => {
    if (pdfSrc) {
      saveAs(
        pdfSrc,
        data.fileName || 'download.pdf'
      );
    }
  };

  return (
    <>
      <div className="PDFShareContainer">
        <div className="BlockGreen">
          <div className='CurveGreen' />
        </div>
        <div className="PdfContainerInner">
          <div className="CompanyName">{data.companyName}</div>
          <div className="PdfTitle">{data.title}</div>
          {pdfError ?
            <div className="PdfError" role="alert">
              <p>{pdfError}</p>
              <button type="button" onClick={retryPdf}>Thử lại</button>
            </div> : pdfSrc ?
            <div onClick={() => window.open(pdfSrc, '_blank')} style={{ cursor: 'pointer' }}>
              <Document
                key={pdfSrc}
                className="customPDF"
                file={pdfSrc}
                onLoadSuccess={onDocumentLoadSuccess}
                onLoadError={onDocumentLoadError}
                onSourceError={onDocumentLoadError}
                loading={<div className="PdfLoading">Đang tải PDF...</div>}
              >
                <Page pageNumber={pageNumber} renderTextLayer={false} />
              </Document>
            </div> :
            <img src="/images/pdf_default.png" className="pdf_default" alt="pdf" />
          }
          <p className="Website">{data.website}</p>
          <button className="ButtonDownload" onClick={saveFile}>
            <span className="download">
              <img src="/images/download.svg" className="BtnDownload" alt="download" />
            </span>
            <p>Download</p>
          </button>
        </div>
      </div>
    </>
  )
}

export default withRouter(PDF);
